/**
 * FilterBar - Search, sort, filter controls and refresh button
 *
 * Provides the toolbar above the pool metrics table with:
 * - Text search (by token ID or currency name)
 * - Sort dropdown
 * - Filter dropdown
 * - Export CSV and Refresh buttons
 *
 * @param {{ searchTerm, onSearchChange, sortBy, onSortChange, filterBy, onFilterChange, onExport, onRefresh, loading }} props
 */

import React from "react";
import { commonStyles } from "../../AgenticPaymentTransactionHistory/styles";
import { SORT_OPTIONS, FILTER_OPTIONS } from "../constants";
import { SearchIcon, RefreshIcon } from "./Icons";

const FilterBar = ({
    searchTerm,
    onSearchChange,
    sortBy,
    onSortChange,
    filterBy,
    onFilterChange,
    onExport,
    onRefresh,
    loading,
}) => {
    return (
        <div style={commonStyles.filterBar}>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    flex: 1,
                    flexWrap: "wrap",
                }}
            >
                {/* Search */}
                <div
                    style={{
                        position: "relative",
                        flex: "1 1 200px",
                        maxWidth: "320px",
                    }}
                >
                    <div
                        style={{
                            position: "absolute",
                            left: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            display: "flex",
                            alignItems: "center",
                            height: "16px",
                        }}
                    >
                        <SearchIcon />
                    </div>
                    <input
                        type="text"
                        placeholder="Search currencies..."
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        style={{
                            ...commonStyles.input,
                            paddingLeft: "40px",
                        }}
                    />
                </div>

                {/* Sort */}
                <select
                    value={sortBy}
                    onChange={(e) => onSortChange(e.target.value)}
                    style={{
                        ...commonStyles.select,
                        width: "auto",
                        minWidth: "160px",
                        cursor: "pointer",
                    }}
                >
                    {SORT_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>

                {/* Filter */}
                <select
                    value={filterBy}
                    onChange={(e) => onFilterChange(e.target.value)}
                    style={{
                        ...commonStyles.select,
                        width: "auto",
                        minWidth: "160px",
                        cursor: "pointer",
                    }}
                >
                    {FILTER_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            </div>

            {/* Export button: the rows as shown, with search, filter and sort applied */}
            <button
                type="button"
                onClick={onExport}
                disabled={loading}
                style={{
                    ...commonStyles.button,
                    background: "#fff",
                    color: "#2e3b61",
                    border: "1px solid #2e3b61",
                    marginRight: "8px",
                    opacity: loading ? 0.6 : 1,
                }}
            >
                Export CSV
            </button>

            {/* Refresh button */}
            <button
                type="button"
                onClick={onRefresh}
                disabled={loading}
                style={{
                    ...commonStyles.button,
                    ...commonStyles.buttonPrimary,
                    gap: "8px",
                    opacity: loading ? 0.6 : 1,
                }}
            >
                <RefreshIcon />
                {loading ? "Refreshing..." : "Refresh Data"}
            </button>
        </div>
    );
};

export default FilterBar;
